import { Form, Modal, Spin } from '@bedrock/components';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import CustomInspectionFields from './CustomInspectionFields';
import { useMemoizedFn } from 'ahooks';
import { demandSourceMatchTemplateDetail } from '#services/api';
import classNames from 'classnames';
import styles from './index.less';
import SFormItem from '@mpc/common/src/components/SForm/SFormItem';
import { localPx2rem } from '#utils';

const cx = classNames.bind(styles);

interface CustomInspectionTemplateDetailPreviewProps {}

export interface CustomInspectionTemplateDetailPreviewRefType {
  open: (detailsId: number) => void;
  close: () => void;
}

const CustomInspectionTemplateDetailPreview = forwardRef<
  CustomInspectionTemplateDetailPreviewRefType,
  CustomInspectionTemplateDetailPreviewProps
>(({}: CustomInspectionTemplateDetailPreviewProps, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [templateName, setTemplateName] = useState('');

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const open = useMemoizedFn((detailsId: number) => {
    setVisible(true);
    setLoading(true);
    demandSourceMatchTemplateDetail({
      id: detailsId,
    })
      .then((res: any) => {
        if (res.code === 1) {
          const data = res.data.demand_source_match_template;
          setTemplateName(data.name);
          form.setFieldsValue({
            demand_source_match_template_field_entities_preview:
              data.demand_source_match_template_field_entities || [],
          });
        }
      })
      .catch((error: any) => {
        console.error('获取详情失败:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  });

  const close = useMemoizedFn(() => {
    setVisible(false);
  });

  return (
    <Modal
      destroyOnClose
      visible={visible}
      onCancel={close}
      onClose={close}
      title={`预览-定制排查${templateName}`}
      width={960}
      footer={null}
      bodyStyle={{ paddingBottom: localPx2rem(20) }}
    >
      {loading && <Spin.Global />}
      <Form form={form} layout="vertical" showLabelColon preserve={false}>
        <SFormItem
          noStyle
          className={cx('custom-form-item-input')}
          formItemKey="demand_source_match_template_field_entities_preview"
          watchChildFormValidate={true}
          validateTrigger={['onChange, onSubmit']}
          readonly={true}
          render={() => <CustomInspectionFields type="preview" />}
        />
      </Form>
    </Modal>
  );
});

export default CustomInspectionTemplateDetailPreview;
